@let vendor = store.vendor();

<ion-header [translucent]="true" style="--ion-toolbar-background: transparent" class="ion-no-border">
  @if (!isHeaderCollapsed()) {
    <ion-toolbar class="absolute z-40" style="--background: transparent; --border-color: transparent">
      <ion-buttons slot="start" class="ms-5 text-white mt-3">
        <ion-back-button defaultHref="/" [text]="'COMMON.BACK' | translate" />
      </ion-buttons>
    </ion-toolbar>
  }

  <!-- Collapsible Header Section -->
  <ion-toolbar
    #collapsibleHeader
    class="flex pwa:h-[310px] native:h-[310px] h-[260px] flex-col transition-all duration-500 ease-in-out overflow-hidden"
    [style.height]="isHeaderCollapsed() ? '0px' : null"
    [style.min-height]="isHeaderCollapsed() ? '0px' : null"
  >
    <div class="pwa:h-[310px] native:h-[310px] h-[260px] relative">
      <mtjr-blur-img
        containerClass="h-full w-full"
        imgClass="h-full w-full object-cover rounded-b-3xl"
        canvasClass="h-full w-full object-cover rounded-b-3xl"
        [blurHash]="vendor?.backgroundBlurHash"
        proxy="https://dev-img.mtjr.ly/unsafe/resize:auto:1920:1080/sm:1/q:85/plain/"
        [src]="vendor?.background"
        alt=""
      />

      <div class="sticky bottom-10 right-0 flex flex-col z-10">
        <ion-item lines="none" style="--background-color: transparent" class="ms-1">
          <mtjr-blur-img
            proxy="https://dev-img.mtjr.ly/unsafe/resize:auto:200:200/sm:1/q:85/plain/"
            [src]="vendor?.logo"
            imgClass="border-light size-16 border-2 border-solid rounded-full me-2"
            alt=""
            [blurHash]="vendor?.logoBlurHash"
          />
          <ion-label>
            <!-- todo: fixme: this should done using tailwind -->
            <p
              class="!text-xl font-bold !text-white"
              style="
                text-shadow:
                  1px 1px 0 rgb(101, 101, 101),
                  -1px -1px 0 rgb(101, 101, 101),
                  1px -1px 0 rgb(101, 101, 101),
                  -1px 1px 0 rgb(101, 101, 101);
              "
            >
              {{ vendor?.name }}
            </p>
            <!-- @if (isDev) {
              <span
                class="!text-xl font-bold !text-white"
                style="
                  text-shadow:
                    1px 1px 0 rgb(101, 101, 101),
                    -1px -1px 0 rgb(101, 101, 101),
                    1px -1px 0 rgb(101, 101, 101),
                    -1px 1px 0 rgb(101, 101, 101);
                "
              >
                {{ vendor?.publishStatus }}
              </span>
            } -->
          </ion-label>
        </ion-item>
      </div>
    </div>
  </ion-toolbar>

  <!-- Sticky Search Bar -->

  <ion-toolbar
    #stickySearchBar
    class="sticky top-0 z-30 !px-4 py-1 shadow-sm transition-all duration-300 ease-in-out"
    style="--background-color: transparent"
    [class.expanded]="isHeaderCollapsed()"
  >
    <div class="flex items-center">
      <ion-back-button
        defaultHref="/"
        text=""
        class="z-50 transition-all duration-500 ms-0 me-2"
        [class.w-0]="!isHeaderCollapsed()"
        [class.min-w-0]="!isHeaderCollapsed()"
        [class.max-w-0]="!isHeaderCollapsed()"
        [class.w-8]="isHeaderCollapsed()"
      />
      <div class="flex flex-wrap items-center flex-1">
        <div class="flex flex-wrap items-center gap-2 flex-1">
          <ion-searchbar
            mode="ios"
            class="flex-1 min-w-[90px] !mb-0 !pb-0 !px-0 transition-all duration-500"
            color="light"
            (ionChange)="handleSearchInput($event)"
            (ionClear)="handleSearchInput()"
            [value]="searchValue()"
            [placeholder]="'COMMON.SEARCH' | translate"
          />
          <ion-button
            color="medium"
            mode="ios"
            (click)="filterModalQuery.set(store.productsListInput())"
            fill="solid"
            style="--border-radius: 10px"
            class="size-[36px] grow-0"
          >
            <ion-icon slot="icon-only" size="small" name="filter"></ion-icon>
          </ion-button>
          <ion-button
            color="medium"
            mode="ios"
            (click)="openShareOptions(vendorId)"
            fill="solid"
            style="--border-radius: 10px"
            class="size-[36px] grow-0"
          >
            <ion-icon size="small" name="share-social-outline" slot="icon-only"></ion-icon>
          </ion-button>
          @if (isVendorOwner) {
            <ion-button
              id="popover-trigger-vendor-details-sticky"
              color="medium"
              mode="ios"
              fill="solid"
              style="--border-radius: 10px"
              class="size-[36px] grow-0"
            >
              <ion-icon slot="icon-only" name="ellipsis-vertical"></ion-icon>
            </ion-button>

            <ion-popover trigger="popover-trigger-vendor-details-sticky" size="cover" [dismissOnSelect]="true">
              <ng-template>
                <ion-content>
                  <ion-list>
                    <ion-item routerLink="edit" [button]="true" [detail]="false">
                      <ion-icon name="create-outline" slot="start"></ion-icon>
                      <ion-label>{{ "VENDORS.EDIT" | translate }}</ion-label>
                    </ion-item>
                    <ion-item (click)="reloadProductsList()" [button]="true" [detail]="false">
                      <ion-icon name="refresh" slot="start"></ion-icon>
                      <ion-label>{{ "COMMON.RELOAD" | translate }}</ion-label>
                    </ion-item>
                  </ion-list>
                </ion-content>
              </ng-template>
            </ion-popover>
          }
        </div>
      </div>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content [scrollEvents]="true" fullscreen="true">
  @switch (store.productsListState().type) {
    @case ("loading") {
      <div class="flex items-center justify-center">
        <ion-spinner class="mt-24 size-10" name="circles" />
      </div>
    }
    @case ("error") {
      <mtjr-error [failure]="store.productsFailure()" />
    }
    @case ("success") {
      <div class="w-full">
        @if (vendor?.vendorType === "voucher") {
          <div
            class="mt-2 gap-2 px-4 pb-36 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-[repeat(auto-fill,minmax(320px,1fr))]"
          >
            @for (product of store.products(); track $index) {
              <div class="aspect-[2/0.5]">
                <mtjr-voucher-card [product]="product" />
              </div>
            }
          </div>
        } @else {
          <div
            class="mt-2 px-4 pb-36 w-full gap-3 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-[repeat(auto-fill,minmax(180px,1fr))]"
          >
            @for (product of store.products(); track $index) {
              <mtjr-product-card [product]="product" />
            }
          </div>
        }
      </div>
      @if (store.products().length === 0) {
        <div class="flex w-full flex-col items-center justify-center">
          <mtjr-dynamic-img
            src="/assets/no_products.svg"
            darkSrc="/assets/no_products_dark.svg"
            class="size-[180px] opacity-80 dark:opacity-70"
          />
          @if (isVendorOwner) {
            <p class="text-medium/70 mt-5 text-center leading-relaxed">
              <span>{{ "VENDORS.NO_PRODUCTS_TO_SHOW" | translate }}</span>
              <br />
              <span>{{ "VENDORS.TAP_TO_CREATE_PRODUCT" | translate }}</span>
            </p>
          } @else {
            <p class="text-medium/70 mt-5 text-center">{{ "VENDORS.NO_PRODUCTS_TO_SHOW" | translate }}</p>
          }
        </div>
      }
    }
  }
  <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>

@if (isVendorOwner) {
  <ion-fab vertical="bottom" horizontal="end">
    <ion-button
      color="primary"
      class="capitalize"
      data-cy="create-product-button"
      routerLink="products/create"
      routerDirection="forward"
    >
      <ion-label class="">{{ "VENDORS.CREATE_PRODUCT" | translate }}</ion-label>
      <ion-icon slot="start" class="!me-2" name="card" />
    </ion-button>
  </ion-fab>
}
<ion-modal
  #filterModal
  data-cy="filter-modal"
  cssClass="rounded-dialog"
  [isOpen]="filterModalQuery() !== undefined"
  (willDismiss)="submitQuery(filterModalQuery()); filterModalQuery.set(undefined)"
  [breakpoints]="[0.0, 0.8]"
  [initialBreakpoint]="0.8"
>
  <ng-template>
    <mtjr-vendor-filter-sheet
      [modal]="filterModal"
      [initialQuery]="store.productsListInput()"
      (queryChanged)="filterModalQuery.set($event)"
    />
  </ng-template>
</ion-modal>

<ion-modal
  [isOpen]="shareModalOpen()"
  (willDismiss)="shareModalOpen.set(false)"
  cssClass="rounded-dialog"
  [breakpoints]="[0.0, 0.35]"
  [initialBreakpoint]="0.35"
>
  <ng-template>
    <ion-header [translucent]="true">
      <ion-toolbar>
        <ion-title>{{ "COMMON.SHARE" | translate }}</ion-title>
        <ion-buttons slot="end">
          <ion-button fill="clear" (click)="shareModalOpen.set(false)">
            <ion-text>
              {{ "COMMON.CANCEL" | translate }}
            </ion-text>
            <ion-icon slot="end" name="close" />
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="bg-surface ion-padding">
      <div class="flex flex-col items-center">
        <div class="grid grid-cols-3 gap-5 w-full">
          <!-- copy -->
          <div class="flex flex-col items-center gap-1" (click)="copyToClipboard(currentShareUrl())">
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-dark mb-1 cursor-pointer">
              <ion-icon name="copy-outline" class="text-2xl text-gray-700"></ion-icon>
            </div>
            <ion-text class="text-xs">{{ "COMMON.COPY_LINK" | translate }}</ion-text>
          </div>

          <!-- Facebook -->
          <div class="flex flex-col items-center gap-1" (click)="shareToSocialMedia('facebook', currentShareUrl())">
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-blue-600 mb-1 cursor-pointer">
              <ion-icon name="logo-facebook" class="text-2xl text-white"></ion-icon>
            </div>
            <ion-text class="text-xs">Facebook</ion-text>
          </div>

          <!-- Twitter/X -->
          <div class="flex flex-col items-center gap-1" (click)="shareToSocialMedia('twitter', currentShareUrl())">
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-black mb-1 cursor-pointer">
              <ion-icon name="logo-twitter" class="text-2xl text-white"></ion-icon>
            </div>
            <ion-text class="text-xs">X</ion-text>
          </div>

          <!-- WhatsApp -->
          <div class="flex flex-col items-center gap-1" (click)="shareToSocialMedia('whatsapp', currentShareUrl())">
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-green-500 mb-1 cursor-pointer">
              <ion-icon name="logo-whatsapp" class="text-2xl text-white"></ion-icon>
            </div>
            <ion-text class="text-xs">WhatsApp</ion-text>
          </div>

          <!-- Telegram -->
          <div class="flex flex-col items-center gap-1" (click)="shareToSocialMedia('telegram', currentShareUrl())">
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-blue-400 mb-1 cursor-pointer">
              <ion-icon name="paper-plane" class="text-2xl text-white"></ion-icon>
            </div>
            <ion-text class="text-xs">Telegram</ion-text>
          </div>

          <!-- Native -->
          <div class="flex flex-col items-center gap-1" (click)="shareToSocialMedia('native', currentShareUrl())">
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-black mb-1 cursor-pointer">
              <ion-icon name="share-social-outline" class="text-2xl text-white"></ion-icon>
            </div>
            <ion-text class="text-xs">Native</ion-text>
          </div>
        </div>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
